<template>
  <div>
    <div class="user_table flex-row flex-wrap">
      <el-card class="user_item" v-for="(item,index) of news" :key="index" @click.native="goCustomerHandler(item)">
        <div class="text item flex-col align-start">
          <div class="flex-row">
            <img :src="item.headImage"/>
          </div>
          <div class="flex-row">
            <div class="label">昵称：</div>
            <div>{{ item.nickname }}</div>
          </div>
          <div class="flex-row">
            <div class="label">手机：</div>
            <div>{{ item.phone }}</div>
          </div>
          <div class="flex-row">
            <div class="label">网点：</div>
            <div>{{ item.posId }}</div>
          </div>
          <div class="flex-row">
            <div class="label">订单：</div>
            <div>{{ item.orderId }}</div>
          </div>
          <div class="flex-row align-start">
            <div class="label">客服：</div>
            <div>{{ item.customerAccount }}</div>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import {getUserEventLog} from "../../api";
import axios from "axios";
import {mapState} from "vuex";

export default {
  name: "monitor_customer",
  props:{
    news: Array,
  },
  computed:{
    ...mapState(["userAllEventLog"])
  },
  mounted() {
    
  },
  methods:{
    // 跳转至门店并传递消息参数
    goCustomerHandler(item) {
      let msgList=[];
      console.log('服务的用户', item);
      this.$router.push({
        path: '/customer_care_handler',
        query: {
          nickname: item.nickname,
          phone: item.phone,
          userAccount: item.userAccount,
          posId:item.posId,
          orderId:item.orderId
        }
      })
    }
  }
}
</script>
<style src="../../css/common.css" scoped>

</style>
<style src="../../css/monitor_screen.css" scoped>
</style>



// WEBPACK FOOTER //
// src/components/monitor_list/monitor_customer.vue